export const npsEventNames = {
  npsFeedbackScreenViewed: "Feedback Screen Viewed NPS",
  npsFeedbackScreenSkippedWithoutScore:
    "Skip Clicked w/o score Feedback Screen NPS",
  npsFeedbackScreenSkippedWithScore:
    "Skip Clicked with score Feedback Screen NPS",
  npsRatingSelectedOnFeedbackScreen: "Rating Selected on Feedback Screen NPS",
  npsSubmitClickedOnFeedbackScreen: "Submit Clicked on Feedback Screen NPS",
  npsSubmitClickedOnFeedbackTextboxBS:
    "Submit Clicked on Feedback Textbox BS NPS",
  npsSkipClickedOnFeedbackTextboxBS: "Skip Clicked on Feedback Textbox BS NPS",
  npsOkayClickedOnThanksScreen: "Okay Clicked on Thanks Screen NPS",
  npsSubmitClickedOnParentNumberForm: "Submit Clicked on Enter Number BS NPS",
  npsSkipClickedWithoutNumberOnParentNumberForm:
    "Skip Clicked w/o Num on Enter Number BS NPS",
  npsSkipClickedWithNumberOnParentNumberForm:
    "Skip Clicked with Num on Enter Number BS NPS",
  npsSubmitClickedOnReNudgeBS: "Submit Clicked on Renudge BS NPS",
  npsSkipClickedOnReNudgeBS: "Skip Clicked on Renudge BS NPS"
};
